export var PROCESS_ALWAYS='PROCESS_ALWAYS';export var PROCESS_LAST='PROCESS_LAST';export var PROCESS_SEQUENTIAL='PROCESS_SEQUENTIAL';